import { RuntimeConfig } from './actions';

/**
 * Stores state of a login request to API
 * Holds useful information such as user groups
 */
export interface ConfigState {
  pending: boolean;
  config: RuntimeConfig;
  error?: string;
}

export const defaultConfigState: ConfigState = {
  pending: false,
  config: {
    deployment: {
      environment: 'development',
      database: 'clone',
    },
    urls: {
      api: '## API URL NOT LOADED ##',
      reports: '## REPORTS URL NOT LOADED ##',
      admin: '## ADMIN URL NOT LOADED ##',
    },
  },
  error: null,
};
